import { ReactNode } from 'react';
import { useServices } from '@packages/shared/core/common/hooks';
import { useQuizStep } from '@packages/shared/core/quiz/hooks';
import { QuizScreenProps, SingleAnswerWithFeedbackStepData } from '@packages/shared/core/quiz/entities';

type SingleAnswerWithFeedbackQuizStepProps = {
  id: string;
  renderQuizScreen: (stepData: QuizScreenProps) => ReactNode;
};

const SingleAnswerWithFeedbackQuizStep = ({ id, renderQuizScreen }: SingleAnswerWithFeedbackQuizStepProps) => {
  const { analyticsService, logger } = useServices();
  const { back, next, stepData, updateUserPreferences, totalSteps, stepOrder } = useQuizStep(id);

  if (!stepData) {
    // TODO add fallback
    logger.error(new TypeError(`Data for ${id} step not found`));
    return null;
  }

  const { dataKey, otherEvent } = stepData as SingleAnswerWithFeedbackStepData;

  const onSelected = (context: string) => {
    if (otherEvent) {
      analyticsService.trackQuizEvent(otherEvent, { context });
    }
  };

  const goBack = async () => back();

  const onChosen = async (text: string, key?: string) => {
    updateUserPreferences(dataKey, text.toLowerCase());
    await next(text, key);
  };

  return (
    <>
      {renderQuizScreen({
        onChosen,
        onSelected,
        onBack: goBack,
        totalSteps,
        stepOrder,
        ...(stepData as SingleAnswerWithFeedbackStepData),
      })}
    </>
  );
};

export default SingleAnswerWithFeedbackQuizStep;
